var path = '/client/front-office/modules/instance/views/partials/instance-block_title.html';
var html = "<a class=\"instance-block-title\" ng-href=\"{{ vm.getLink() }}\" target=\"_blank\">\n    {{ ::vm.instance.title | trans }}\n</a>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;